/**
 * 客服
 * createTime 2021-10-19 10:47:45
 * updateTime 2021-10-19 10:47:45
 */

import fetch from '@/utils/fetch'

/**
 * 人工处理
 * YAPI: https://doc.jsxygkj.com/project/257/interface/api/7026
 * 备注:
 */
export function postCustomerManual(data, other = {}) {
  return fetch({
    url: `/reservation/customer/manual`,
    method: 'POST',
    data,
    ...other
  })
}

/**
 * 客服咨询历史
 * YAPI: https://doc.jsxygkj.com/project/257/interface/api/7019
 * 备注:
 */
export function postCustomerHistory(params, other = {}) {
  return fetch({
    url: `/reservation/customer/history`,
    method: 'GET',
    params,
    ...other
  })
}

/**
 * 客服咨询历史
 * YAPI: https://doc.jsxygkj.com/project/257/interface/api/7019
 * 备注:
 */
export function addConsultHistory(data, other = {}) {
  return fetch({
    url: `/reservation/customer/addHistory`,
    method: 'POST',
    data,
    ...other
  })
}

/**
 * 客服咨询接口
 * YAPI: https://doc.jsxygkj.com/project/257/interface/api/7012
 * 备注:
 */
export function postCustomerConsult(data, other = {}) {
  return fetch({
    url: `/reservation/customer/consult`,
    method: 'POST',
    data,
    ...other
  })
}

/**
 * 已解决
 * YAPI: https://doc.jsxygkj.com/project/257/interface/api/7033
 * 备注:
 */
export function postCustomerResolve(data, other = {}) {
  return fetch({
    url: `/reservation/customer/resolve`,
    method: 'POST',
    data,
    ...other
  })
}
